// @ts-ignore
export { CommentsSectionLoader } from './CommentsSectionLoader';
